import React, {useContext, useEffect, useRef, useState} from 'react'
import t from 'helpers/I18n'


import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import StepFooterAction from "../../base-components/step-footer-action";
import InputField from "../../base-components/base-input";
import { useHistory } from 'react-router-dom';
import { AppDataContext } from 'contexts/app-data'
import BottomSheet from '../../modals/bottom-sheet';
import { HiOutlineLightBulb } from 'react-icons/hi'




const HasEstablishmentDate = ({_step_service, next_step, step_ID, step_URL, step_form, error, getDataFromContext, setDataToContext}) => {
    const [isValid, setIsValid] = useState(false)
    const form = useRef()
    const {state, dispatch} = useContext(AppDataContext)

    const history = useHistory();
    const data = getDataFromContext(step_ID)
    const [showModal, setShowModal] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [is18, setIs18] = useState(true)
    const [inputData, setInputData] = useState({ ...{[step_ID] : data?.[step_ID]?.split("-").reverse().join('/')} })

    const mock_error = [
        //{id: "firstName", message:"testmessage particulier"},
        //{id: "lastName", message:"test"},
    ]

    const getInputValue = (name, value) => {
        if (value.length > 0) {
               setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value && value.split("/").reverse().join("-"))
        }
    }

    const _error = error.length > 0 || mock_error
    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    useEffect(() => {
        setIsValid(isValidForm())
    }, [inputData])
                       useEffect(() => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "3",
stepName: "pro info:what is your establishment date",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }

     }, [])


    const isValidForm = () => {
        const valToVlidate = inputData.establishment_date
        const dt = valToVlidate?.split("/")
        const inputDate = dt && new Date(dt[2], dt[1] - 1, dt[0])

        let max100Yers = new Date()
        max100Yers.setFullYear(max100Yers.getFullYear() - 100)
        max100Yers.setDate(max100Yers.getDate() - 1)

        let today = new Date()
        today.setDate(today.getDate()  + 1)

        const validFeb =  dt && Number(dt[1]) === 2 ? Number(dt[0]) <= 29 ? true : false : true 
        
        return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        }) && !valToVlidate.includes("_")
            && !dt[0].includes('_') && dt[0] < 32 && dt[0] > 0 &&
            !dt[1].includes('_') && dt[1] < 13 && dt[1] > 0 &&
            !dt[2].includes('_') && dt[2] > 0 && validFeb && inputDate > max100Yers && inputDate <= today
    }

    return (
        <>
            <StepsLoader loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
              <h3>{t('pro_infos.pro_info_what_is_your_establishment_date.title1')}</h3>
                    </BaseParagraph>
                        <InputField
                            type={"date"}
                            label={t('pro_infos.pro_info_what_is_your_establishment_date.label')}
                            // label={"date"}
                            value={inputData[step_ID]}
                            name={step_ID}
                            getInputValue={getInputValue}
                        error={_error}
                        notBirthdate={true}
                            noFuture={true}
                        />
                </form>
                
          <StepFooterAction caption={t('general.continue')} action={action} link={next_step} disabled={!isValid} />

            </StepsLoader>

        </>
    )
}

HasEstablishmentDate.propTypes = {
    error: PropTypes.array,
    _step_service: PropTypes.func,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
}


export default HasEstablishmentDate